/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-group[_ngcontent-%COMP%]{width:inherit!important}.canvas[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;border:2px solid #ccc;border-radius:20px;padding:25px 10px 0;margin-bottom:10px}.delete-button[_ngcontent-%COMP%]{cursor:pointer!important;margin-top:-10px}.form-control[_ngcontent-%COMP%]{width:100%}p[_ngcontent-%COMP%]{padding:0;float:right}.w-100[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
